<template lang="pug">
.bloco-resumo
    .bloco-resumo__coluna
        .bloco-resumo__cabecalho
            span {{ titulo }}
            span {{ subTitulo }}

        .bloco-resumo__linha(v-for='(item, index) in resumo' :key='`resumo-tabela-${index}`')
            span.bloco-resumo__titulo {{ item.titulo || '-' }}
            span.bloco-resumo__valor {{ item.valor || '-' }}

</template>

<script>
export default {
    name: 'BlocoResumoContratoOriginacao',

    props: {
        titulo: {
            required: true,
            type: String
        },
        subTitulo: {
            required: true,
            type: String
        },
        resumo: {
            required: true,
            type: Array
        }
    }
};
</script>

<style lang="scss">
.bloco-resumo {
    background-color: #fff;
    border-radius: $default-border-radius;
    .bloco-resumo__linha,
    .bloco-resumo__cabecalho {
        display: flex;
        justify-content: space-between;
        padding: 16px;
        span {
            margin-bottom: 0px;
        }
    }
    .bloco-resumo__titulo {
        color: var(--primary);
        font-weight: 600;
    }
    .bloco-resumo__cabecalho {
        font-weight: bold;
        border-radius: $default-border-radius $default-border-radius 0 0;
        padding: 16px;
        font-weight: 600;

        background-color: #D8D8D8;
        color: var(--primary);
    }

    .bloco-resumo__linha:nth-child(odd) {
        background-color: var(--list-background-contrast);
    }
}
</style>
